import React from 'react';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useSiteContent } from '../../context/SiteContentContext';

const AboutTeaser = () => {
  const { siteContent } = useSiteContent();
  const aboutTeaser = siteContent?.aboutTeaser || {};

  if (aboutTeaser.visible === false) return null;

  return (
    <section className="py-14 sm:py-16 md:py-20 bg-white">
      <div className="max-w-2xl mx-auto px-5 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        >
          <span className="text-xs sm:text-sm font-medium text-slate-400 uppercase tracking-wider mb-3 sm:mb-4 block">
            {aboutTeaser.label || 'About Us'}
          </span>
          <p className="text-base sm:text-lg md:text-xl text-slate-600 leading-relaxed mb-5 sm:mb-6">
            {aboutTeaser.text || 'Patient teachers. Personalized guidance. Confidence that lasts.'}
          </p>
          <Link
            to="/about"
            className="inline-flex items-center text-sm font-medium text-slate-900 hover:text-slate-600 transition-colors py-2"
          >
            {aboutTeaser.linkText || 'Read more'}
            <ArrowRight className="ml-2 w-4 h-4" />
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutTeaser;
